// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeCtf = {
  ctfAuthMemberAccessRequired: "現在の SSO ID に対応する CTF メンバーがありません",
  ctfAuthMemberInactive: "対応する CTF メンバーが active 状態ではありません",
  ctfMemberNotFound: "CTF メンバー {member_id} が見つかりません",
  ctfMemberUserIdRequired: "CTF メンバーリクエストに user_id がありません",
  ctfMemberUsernameRequired: "CTF メンバーリクエストにユーザー名がありません",
  ctfMemberDuplicateUserId: "CTF メンバーリクエストに user_id {user_id} が重複しています",
  ctfMemberAlreadyExists: "CTF メンバーが既に存在します: {user_ids}",
  ctfMemberInvalidRoles: "CTF メンバーのロールが無効です",
  ctfPlatformApplicationNotFound: "CTF プラットフォームアプリケーション {app_key} が見つかりません",
  ctfPlatformDataContractInvalid:
    "CTF プラットフォームデータ契約が無効です ({field_name}: {reason})",
  ctfBusinessEventInboxRetryLater: "CTF イベントは後で再試行されるまで待機しています",
  ctfBusinessEventUnexpectedRetryableFailure:
    "CTF イベントで予期しない再試行可能な失敗が発生しました",
} as const;
